import Vue from 'vue'
import { Bar, Line } from 'vue-chartjs'

Vue.component('LineChart', Line);
Vue.component('BarChart', Bar);